import { H2, Image, SpacerWrapper, Wrapper } from '@ahmdigital/ui';
import { PRODUCT_LIMIT_CATEGORY } from '@ahmdigital/constants';
import styled from 'styled-components';

import { LimitGroup } from '../../types';
import getOrthodonticsLifetimeLimit from '../../../../../../utils/get-orthodontics-lifetime-limit';
import ServiceGroupPanel from '../service-group-panel';
import toothImage from './images/tooth.svg';

const SectionWrapper = styled.section`
  position: relative;
`;

const AnchorId = styled.div`
  position: absolute;
  top: -1.5rem;
`;

const PanelImage = styled(Image)`
  max-width: initial;
`;

type BaseBundleSectionProps = {
  includedServices?: LimitGroup;
  scale: string;
  isBundleChosen?: boolean;
};

const BaseBundleSection = ({ includedServices, scale, isBundleChosen = false }: BaseBundleSectionProps) => {
  if (!includedServices) {
    return null;
  }

  const { limits } = includedServices;

  return (
    <SectionWrapper>
      <AnchorId id="base-bundle-section" />
      <Wrapper size="medium">
        <SpacerWrapper variant="marginBottomSpacer7">
          <H2 looksLike="h3" variant="center">
            Start with our base bundle …
          </H2>
        </SpacerWrapper>
      </Wrapper>

      <ServiceGroupPanel
        id={PRODUCT_LIMIT_CATEGORY.TEETH}
        isDisabled
        isSelected
        image={<PanelImage src={toothImage.src} alt="Illustration of a tooth" />}
        limits={{ ...limits, lifetime: getOrthodonticsLifetimeLimit(includedServices.services) }}
        scale={scale}
        services={includedServices.services}
        title={includedServices.displayName}
        withButton={isBundleChosen}
        withExtraDetails={!isBundleChosen}
      />
    </SectionWrapper>
  );
};

export default BaseBundleSection;
